import { Button, Label, Switch } from '@repo/shadcn';
import { Printer } from 'lucide-react';
import { Link } from 'react-router-dom';

import { PaymentStatusBadge } from '@components/ui/badge';

import { useOrderDetailsContext } from './context';

export const InvoiceHeader = () => {
    const { data, handlePrintInvoice, showDiscount, setShowDiscount } =
        useOrderDetailsContext();

    return (
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-start">
            <div>
                <h1 className="flex items-center gap-3 text-xl font-bold text-foreground">
                    <span>
                        Invoice No: {data?.data?.invoice_number ?? '---'}
                    </span>
                    <PaymentStatusBadge status={data?.data?.status} />
                </h1>
                <p className="text-sm">
                    Date:{' '}
                    {new Date(
                        data?.data?.created_at ?? Date.now(),
                    ).toLocaleDateString()}
                </p>
                <p className="text-sm">
                    Served By:{' '}
                    {data?.data?.user?.name ? (
                        <Link to={`/users/${data.data.user.id}`}>
                            <Button variant="link" className="m-0 p-0">
                                {data.data.user.name}
                            </Button>
                        </Link>
                    ) : (
                        '---'
                    )}
                </p>
            </div>
            <div className="flex flex-col items-end gap-3">
                <Button
                    className="gap-2 bg-transparent"
                    variant={'outline'}
                    onClick={handlePrintInvoice}
                >
                    <Printer className="h-4 w-4" />
                    Print Invoice
                </Button>
                <div className="flex items-center gap-2">
                    <Switch
                        id="show-discount-checkbox"
                        checked={showDiscount}
                        onCheckedChange={(checked) =>
                            setShowDiscount(!!checked)
                        }
                    />
                    <Label htmlFor="show-discount-checkbox">
                        Show discount
                    </Label>
                </div>
            </div>
        </div>
    );
};

InvoiceHeader.displayName = 'InvoiceHeader';
